/**
 * Утилиты для загрузки разных типов данных
 * @module loaders
 * @memberof module:media
 */

/**
 * @typedef ProgressInfo
 * @property {number} total Total items
 * @property {number} complete Completed items
 * @property {number} progress Comletion progress 0-1
 */

import { parseURL } from '../../net/helpers';

import QueueItem from './QueueItem';
import AJAXLoader from './AJAXLoader';
import JSONLoader from './JSONLoader';
import XMLLoader from './XMLLoader';
import ImageLoader from './ImageLoader';
import SoundLoader from './SoundLoader';
import SpineLoader from './SpineLoader';
import Queue from './Queue';
import SyncQueue from './SyncQueue';

//----------------------------------------------------------------------------------------------------------------------
let DefaultLoader = AJAXLoader, LOADER_MAP = new Map();
function registerLoader(cls, ...exts) {
    for (let ext of exts) {
        LOADER_MAP.set(ext.toLowerCase(), cls);
    }
}

function detectLoader(url) {
    let ext = (parseURL(url).extension || '').toLowerCase();
    return LOADER_MAP.has(ext) && LOADER_MAP.get(ext) || DefaultLoader;
}

function createLoader(url, ...args) {
    let cls = detectLoader(url);
    return new cls(url, ...args);
}

// Built-in loaders
registerLoader(JSONLoader, 'json');
registerLoader(XMLLoader, 'xml');
registerLoader(ImageLoader, 'png', 'jpg', 'jpeg', 'gif', 'bmp');
registerLoader(SoundLoader, 'wav', 'mp3', 'ogg', 'aac');
//----------------------------------------------------------------------------------------------------------------------

export {
    registerLoader,
    detectLoader,
    createLoader,
    QueueItem,
    AJAXLoader,
    JSONLoader,
    XMLLoader,
    ImageLoader,
    SoundLoader,
    SpineLoader,
    Queue,
    SyncQueue
};
